import React from 'react';
import { CheckCircle2, ShieldCheck, Ban, FileCheck, Scale } from 'lucide-react';
import { compliancePoints } from '../../data/mock';

const iconMap = [
  CheckCircle2,
  Ban,
  Ban,
  ShieldCheck,
  FileCheck,
];

const Compliance = () => {
  return (
    <section id="compliance" className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-blue-400 font-medium text-sm tracking-wider uppercase mb-4 block">
              Compliance & Transparency
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Built on Trust and
              <span className="text-blue-400"> Regulatory Compliance</span>
            </h2>
            <p className="text-slate-400 text-lg leading-relaxed mb-8">
              As a B2B technology provider, Botlab Solutions maintains strict operational 
              boundaries and full regulatory compliance. We provide infrastructure and 
              software solutions only – we do not operate platforms or handle end-user transactions.
            </p>

            <div className="space-y-4">
              {compliancePoints.map((point, index) => {
                const IconComponent = iconMap[index] || CheckCircle2;
                return (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 bg-slate-900/50 rounded-xl border border-slate-800 hover:border-blue-500/20 transition-colors group"
                  >
                    <div className="w-10 h-10 bg-blue-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500/20 transition-colors">
                      <IconComponent className="w-5 h-5 text-blue-400" />
                    </div>
                    <span className="text-slate-300 font-medium">{point}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-slate-800/80 to-slate-800/40 rounded-3xl border border-slate-700/50 p-10">
              {/* Shield Icon */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-blue-500/10 rounded-full flex items-center justify-center">
                <Scale className="w-10 h-10 text-blue-400" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-6">Our Commitment</h3>
              
              <div className="space-y-6">
                <div className="pb-6 border-b border-slate-700/50">
                  <h4 className="text-lg font-semibold text-white mb-2">Technology Provider Only</h4>
                  <p className="text-slate-400">
                    We build and supply software platforms and infrastructure. 
                    We do not operate any gambling or gaming platforms.
                  </p>
                </div>

                <div className="pb-6 border-b border-slate-700/50">
                  <h4 className="text-lg font-semibold text-white mb-2">No End-User Funds</h4>
                  <p className="text-slate-400">
                    We do not accept, process, or handle any funds from end users. 
                    All financial transactions are B2B only.
                  </p>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-white mb-2">Fully Licensed</h4>
                  <p className="text-slate-400">
                    Operating as a licensed Free Zone company under RAKEZ 
                    with full corporate transparency.
                  </p>
                </div>
              </div>
            </div>

            {/* Background Decoration */}
            <div className="absolute -z-10 -bottom-8 -left-8 w-full h-full bg-gradient-to-br from-blue-500/10 to-cyan-500/5 rounded-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compliance;
